// extracted by mini-css-extract-plugin
export default {"logo":"StudentView_logo__KReBE","logo2":"StudentView_logo2__nbN52"};